import LinkRouter from '../../../../common/components/presentation/linkRouter/LinkRouter';
import React, { FunctionComponent } from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import changeModelLinkStyles from './changeModelLinkStyles';
import Typography from '@material-ui/core/Typography';
import { ROUTES } from '../../../../common/constants/routes';
import Translation from '../../../../gqlCommon/components/translation/Translation';

export interface IChangeModelLinkProps {
  /**
   * Data test used on integration testing
   */
  dataTest?: string;
  isGraphql?: boolean;
}

const ChangeModelLink: FunctionComponent<IChangeModelLinkProps> = ({ dataTest, isGraphql }) => {
  const styles = changeModelLinkStyles();

  return (
    <LinkRouter className={styles.container} to={ROUTES.MODELS} data-test={dataTest}>
      <ArrowBackIosIcon className={styles.icon} />
      <Typography className={styles.label}>
        <Translation
          id={
            isGraphql
              ? 'trans__configurator__customise_page_summary_section__change_model_link'
              : 'spc.customise.changeModel'
          }
        />
      </Typography>
    </LinkRouter>
  );
};

export default ChangeModelLink;
